<template>
<div class="">
    <PageBreadcrumb :pagetitle="articledetail.title"/>
    <!-- Single Detail -->
    <section v-if="noerror" class="singlesec py-5">
        <div class="container">
            <div class="row">
                <div class="col-12 col-lg-9 mb-5 mb-lg-0">
                    <div class="single-news">
                        <div class="singleimage shrink-effect gradient-full">
                            <img v-bind:src="articledetail.field_basic_image" alt="" class="img-fluid w-100" />
                        </div>
                        <div class="single-title text-center my-4">
                            <h4>{{ articledetail.title }}</h4>
                            <div class="author text-dark font-weight-bold">
                                <span><i class="fa fa-user-o"></i> {{ articledetail.uid }} on</span>
                                <span><i class="fa fa-calendar"></i> {{ articledetail.created }}</span>
                                <span><i class="fa fa-clock-o"></i> {{ articledetail.revision_timestamp }} </span>
                            </div>
                        </div>
                        <p>{{ articledetail.body }}</p>
                        <FormContacts />
                    </div>
                </div>
                <div class="col-12 col-lg-3">
                    <!-- Start SideBarExtras -->
                    <SideBarExtras />
                    <!-- Start SideBarExtras -->
                    <hr>
                    <!-- Start Latest News Sidebar -->
                    <LatestNews />
                    <!-- End Latest News Sidebar -->
                </div>
            </div>
        </div>
    </section>
    <!-- End Single Detail -->
</div>
</template>

<script>
import axios from 'axios';
import PageBreadcrumb from '@/components/PageBreadcrumb';
import LatestNews from "../components/LatestNews";
import SideBarExtras from "../components/SideBarExtras";
import FormContacts from "../components/FormContacts/FormContacts";
export default {
    name: 'SingleDetail',
    props: ['id'],
    components:{
        PageBreadcrumb, LatestNews, SideBarExtras, FormContacts
    },
    data () {
        return {
            noerror: false,
            info: { title : "Detail" },
            articledetail:null
        }
    },
    mounted() {
        axios
        .get('https://api.fifmi.org.au/api/articles')
        .then(result => {
            for (var i = 0; i < result.data.length; i++) {
                if(result.data[i].field_domain_access.includes('fifmi') && result.data[i].type == "article"){
                    result.data[i].current_path = result.data[i].current_path.split('/').pop();
                    if(result.data[i].current_path == this.id){
                        this.articledetail = result.data[i];
                        this.noerror = true
                    }
                }
            }
        })
        .catch(error => {
            if(error)
            this.noerror = false
        });
    },
}
</script>
